import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { IRenderTemplateRow } from '../types';
import { evaluateDependencyItem, shouldRenderEmptyComponent } from '../utils';
import { themeVar } from '@/styles/theme';

interface HtmlComponentProps {
  row: IRenderTemplateRow;
  pageName?: string;
  htmlString: string;
}

export const HtmlComponent = ({ row, pageName, htmlString }: HtmlComponentProps) => {
  const { dependsOn } = row;
  const { watch } = useFormContext();
  const dependentValue = dependsOn ? watch(`${pageName}.${dependsOn.name}`) : null;
  const hasValidOrDependency: boolean = dependsOn?.or
    ? dependsOn.or.some((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;
  const hasValidAndDependency: boolean = dependsOn?.and
    ? dependsOn.and.every((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;

  if (shouldRenderEmptyComponent(dependsOn, dependentValue, hasValidOrDependency, hasValidAndDependency)) return <></>;

  return <StyledHtmlComponent dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

const StyledHtmlComponent = styled.div`
  color: ${themeVar('font.base')};
`;
